var _circle, _circle2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 182,
    viewBox: "0 0 183 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 91.5,
    cy: 91,
    r: 91,
    fill: "#BC172F",
    fillOpacity: 0.05
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.3067,
    cy: 91.1924,
    r: 74.9639,
    fill: "#BC172F",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_980_37294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.815 56.7118L96.3304 44.3234C96.1646 44.2035 95.97 44.1296 95.7664 44.1093C95.5628 44.0889 95.3574 44.1228 95.1711 44.2075L93.6255 45.1001C93.4556 45.2192 93.3209 45.3817 93.2352 45.5707C93.1496 45.7596 93.1162 45.9681 93.1386 46.1743V104.971C93.169 105.544 93.3339 106.102 93.6199 106.599C93.9058 107.096 94.3049 107.519 94.7847 107.834L116.269 120.219C116.435 120.339 116.63 120.412 116.833 120.433C117.037 120.453 117.242 120.419 117.428 120.335L118.974 119.438C119.141 119.319 119.274 119.157 119.358 118.97C119.442 118.782 119.475 118.576 119.453 118.372V59.5712C119.424 58.9995 119.26 58.4427 118.975 57.9459C118.691 57.4492 118.293 57.0264 117.815 56.7118Z",
    fill: "#6D0D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7712 105.979L96.2256 106.875V111.763C96.2324 111.906 96.273 112.046 96.3442 112.17C96.4154 112.294 96.5152 112.4 96.6352 112.478L97.3616 112.899C97.4891 112.964 97.6301 112.998 97.7732 112.998C97.9162 112.998 98.0572 112.964 98.1847 112.899L98.9111 112.478C99.1667 112.313 99.3651 112.072 99.4792 111.79L100.87 107.768L97.7712 105.979Z",
    fill: "#6D0D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2256 111.765C96.2324 111.908 96.273 112.048 96.3442 112.172C96.4154 112.296 96.5152 112.402 96.6352 112.48L97.3616 112.901C97.4116 112.931 97.4677 112.95 97.5258 112.955C97.5839 112.961 97.6425 112.953 97.6971 112.932C97.7518 112.912 97.8011 112.879 97.8414 112.837C97.8816 112.795 97.9118 112.744 97.9297 112.689L99.3207 108.666L96.2294 106.877L96.2256 111.765Z",
    fill: "#BC172F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.267 114.908L111.722 115.805V120.693C111.729 120.836 111.771 120.975 111.843 121.1C111.915 121.224 112.015 121.329 112.135 121.408L112.858 121.825C112.985 121.892 113.127 121.927 113.271 121.927C113.415 121.927 113.557 121.892 113.685 121.825L114.407 121.408C114.663 121.242 114.861 121.002 114.975 120.72L116.366 116.697L113.267 114.908Z",
    fill: "#6D0D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.718 120.695C111.726 120.838 111.767 120.977 111.839 121.102C111.911 121.226 112.011 121.331 112.131 121.41L112.854 121.827C112.903 121.857 112.959 121.876 113.017 121.882C113.075 121.887 113.134 121.88 113.188 121.86C113.243 121.84 113.292 121.808 113.333 121.766C113.373 121.724 113.404 121.674 113.422 121.618L114.817 117.596L111.725 115.807L111.718 120.695Z",
    fill: "#BC172F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8895 45.2464L116.374 57.6348C116.854 57.9481 117.254 58.3703 117.541 58.8671C117.828 59.364 117.993 59.9214 118.024 60.4942V119.295C118.064 119.5 118.038 119.714 117.952 119.904C117.865 120.095 117.72 120.254 117.539 120.359C117.357 120.464 117.148 120.51 116.939 120.49C116.73 120.47 116.533 120.386 116.374 120.249L94.8895 107.861C94.4085 107.547 94.0081 107.125 93.7207 106.629C93.4334 106.132 93.2672 105.574 93.2356 105.001V46.2008C93.2144 45.9948 93.2487 45.7869 93.335 45.5987C93.4213 45.4105 93.5564 45.2488 93.7264 45.1305C93.9131 45.045 94.1192 45.0107 94.3236 45.0311C94.528 45.0515 94.7232 45.1258 94.8895 45.2464Z",
    fill: "#BC172F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6904 125.643L86.9292 139.059L119.465 120.276L117.916 119.379L94.6729 105.963L63.6904 123.854V125.643Z",
    fill: "#E8455C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9287 139.059V137.27L119.465 118.486V120.275L86.9287 139.059Z",
    fill: "#6D0D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9561 136.372C91.3032 129.803 91.0598 118.172 90.6888 116.209C90.6888 116.209 92.5204 128.501 94.777 132.009",
    stroke: "#FAFAFA",
    strokeWidth: 0.285945,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.46 120.678C92.2057 124.26 100.684 126.791 100.684 126.791",
    stroke: "#FAFAFA",
    strokeWidth: 0.285945,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6279 124.24C90.7215 124.087 90.8589 123.965 91.0224 123.891C91.1859 123.817 91.3678 123.793 91.5448 123.824C91.7217 123.854 91.8855 123.937 92.0148 124.062C92.1441 124.186 92.2331 124.347 92.2702 124.522C92.2702 124.522 92.4054 122.783 93.3869 123.278",
    stroke: "#FAFAFA",
    strokeWidth: 0.285945,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2881 126.789C90.7247 125.854 92.3322 125.34 93.0393 127.562C93.0393 127.562 93.1437 123.597 95.7674 124.787",
    stroke: "#FAFAFA",
    strokeWidth: 0.285945,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.542 130.303C90.4655 128.529 92.9849 127.826 93.6341 129.456C93.6341 127.439 95.9526 124.901 98.7734 126.122",
    stroke: "#FAFAFA",
    strokeWidth: 0.285945,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9834 134.565C89.0654 132.602 91.7123 129.062 94.0114 130.488",
    stroke: "#FAFAFA",
    strokeWidth: 0.285945,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.366 100.598V102.387L86.9292 119.381L63.6904 105.965L63.6865 104.176L93.1272 87.1816L116.366 100.598Z",
    fill: "#6D0D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.366 100.598L86.9292 117.592L63.6865 104.176L93.1272 87.1816L116.366 100.598Z",
    fill: "#E8455C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.366 80.9182V82.7073L86.9292 99.7017L63.6904 86.2854L63.6865 84.4963L93.1272 67.502L116.366 80.9182Z",
    fill: "#6D0D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.366 80.9182L86.9292 97.9126L63.6865 84.4963L93.1272 67.502L116.366 80.9182Z",
    fill: "#E8455C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8261 74.5753L65.3416 62.2102C65.1758 62.0902 64.9812 62.0163 64.7776 61.996C64.574 61.9756 64.3686 62.0095 64.1823 62.0942L62.6251 62.983C62.4559 63.1018 62.3215 63.2636 62.2359 63.4518C62.1503 63.64 62.1165 63.8477 62.1382 64.0533V122.838C62.169 123.411 62.3345 123.968 62.6212 124.465C62.9079 124.962 63.3077 125.384 63.7882 125.698L85.2727 138.086C85.4389 138.205 85.6336 138.278 85.8372 138.298C86.0408 138.318 86.246 138.283 86.4319 138.198L87.9776 137.302C88.1448 137.182 88.2773 137.021 88.3615 136.833C88.4457 136.646 88.4785 136.439 88.4567 136.235V77.4348C88.4281 76.8637 88.2655 76.3074 87.9823 75.8107C87.699 75.314 87.303 74.8908 86.8261 74.5753Z",
    fill: "#6D0D1B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M86.9247 83.5977L88.4742 82.7051V77.334L86.917 78.2305L86.9247 83.5977Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M117.917 65.711L119.47 64.8145V59.4473L117.913 60.3437L117.917 65.711Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.783 123.85L65.2373 124.742V129.634C65.2444 129.777 65.2852 129.917 65.3564 130.041C65.4275 130.165 65.5271 130.271 65.6469 130.349L66.3734 130.766C66.5009 130.831 66.6419 130.865 66.7849 130.865C66.9279 130.865 67.0689 130.831 67.1964 130.766L67.919 130.349C68.1806 130.185 68.3856 129.945 68.5063 129.661L69.8974 125.639L66.783 123.85Z",
    fill: "#6D0D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2373 129.636C65.2444 129.779 65.2852 129.918 65.3564 130.043C65.4275 130.167 65.5271 130.273 65.6469 130.351L66.3734 130.768C66.4233 130.799 66.4794 130.817 66.5375 130.822C66.5956 130.828 66.6542 130.82 66.7089 130.8C66.7635 130.779 66.8128 130.747 66.8531 130.704C66.8934 130.662 66.9236 130.611 66.9414 130.556L68.3325 126.533L65.2412 124.744L65.2373 129.636Z",
    fill: "#BC172F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.279 132.775L80.7334 133.668V138.56C80.7412 138.703 80.7827 138.843 80.8546 138.967C80.9264 139.091 81.0266 139.197 81.1469 139.275L81.8695 139.692C81.9976 139.757 82.1393 139.791 82.2829 139.791C82.4266 139.791 82.5682 139.757 82.6964 139.692L83.419 139.275C83.6757 139.109 83.8742 138.867 83.987 138.583L85.3819 134.564L82.279 132.775Z",
    fill: "#6D0D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7294 138.562C80.7372 138.705 80.7787 138.845 80.8506 138.969C80.9224 139.093 81.0226 139.199 81.1429 139.277L81.8655 139.694C81.9141 139.722 81.9681 139.738 82.0238 139.743C82.0795 139.748 82.1356 139.74 82.1881 139.721C82.2406 139.702 82.2884 139.672 82.3281 139.632C82.3678 139.593 82.3985 139.546 82.418 139.493L83.813 135.471L80.7217 133.682L80.7294 138.562Z",
    fill: "#BC172F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7868 63.0847L85.2713 75.473C85.7523 75.7862 86.1527 76.2083 86.44 76.7051C86.7274 77.2019 86.8935 77.7594 86.9251 78.3325V139.057C86.9251 139.057 85.7272 138.35 85.2713 138.087L63.7868 125.699C63.3063 125.386 62.9065 124.963 62.6198 124.466C62.3331 123.97 62.1676 123.412 62.1368 122.839V64.0391C62.118 63.836 62.153 63.6315 62.2385 63.4463C62.324 63.261 62.4569 63.1017 62.6237 62.9842C62.8091 62.8966 63.0145 62.8597 63.2188 62.8773C63.4231 62.895 63.6191 62.9665 63.7868 63.0847Z",
    fill: "#BC172F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M85.2727 75.4735L63.7882 63.0852C63.6224 62.9652 63.4279 62.8913 63.2242 62.871C63.0206 62.8506 62.8153 62.8845 62.629 62.9692C62.4598 63.088 62.3254 63.2499 62.2398 63.4381C62.1542 63.6263 62.1205 63.834 62.1421 64.0396V69.2871L86.9305 83.5843V78.333C86.8985 77.7596 86.7317 77.2018 86.4436 76.7049C86.1556 76.2081 85.7544 75.7862 85.2727 75.4735Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7686 72.8634L114.813 63.0254V80.9124",
    stroke: "#FAFAFA",
    strokeWidth: 0.285945,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.719 76.4416L114.818 63.0254L108.62 73.7599",
    stroke: "#FAFAFA",
    strokeWidth: 0.285945,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.816 63.0254L105.519 71.967",
    stroke: "#FAFAFA",
    strokeWidth: 0.285945,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.817 78.0561C114.817 75.5483 111.954 75.4092 111.954 75.4092C112.053 74.9068 112.018 74.3873 111.853 73.9025C111.688 73.4177 111.4 72.9846 111.015 72.6463C110.092 71.8735 109.47 72.2909 109.28 72.6116C109.28 72.6116 109.477 70.2931 107.483 70.0844C107.483 70.0844 108.805 67.6462 107.483 67.2598",
    stroke: "#FAFAFA",
    strokeWidth: 0.285945,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.817 74.1898C114.717 72.907 113.735 71.2763 112.727 72.0607C112.727 72.0607 112.99 69.2631 110.996 69.6302C110.996 69.6302 111.931 67.0296 109.968 67.6749C109.968 67.6749 111.382 65.8858 110.285 65.627",
    stroke: "#FAFAFA",
    strokeWidth: 0.285945,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.139 56.7679C123.12 56.5627 123.048 56.3661 122.928 56.1984C122.809 56.0306 122.647 55.8978 122.459 55.8134L99.4208 42.5054C98.9087 42.2463 98.3429 42.1113 97.7689 42.1113C97.195 42.1113 96.6291 42.2463 96.117 42.5054L60.6908 62.9852C60.5043 63.0677 60.3428 63.198 60.2227 63.3629C60.1026 63.5277 60.0282 63.7214 60.0068 63.9242C60.0068 64.2411 60.0068 65.3926 60.0068 65.7133C60.0258 65.9178 60.0988 66.1136 60.2183 66.2806C60.3378 66.4476 60.4995 66.5799 60.6869 66.6639L83.7248 79.9642C84.2369 80.2233 84.8028 80.3582 85.3767 80.3582C85.9506 80.3582 86.5165 80.2233 87.0286 79.9642L122.459 59.5075C122.646 59.4235 122.808 59.2912 122.927 59.1242C123.047 58.9572 123.12 58.7614 123.139 58.557C123.135 58.2362 123.135 57.0886 123.139 56.7679Z",
    fill: "#BC172F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7248 78.1741L60.6908 64.8738C59.7789 64.3483 59.7789 63.4943 60.6908 62.9688L96.1209 42.5044C96.6325 42.246 97.1977 42.1113 97.7709 42.1113C98.3441 42.1113 98.9092 42.246 99.4208 42.5044L122.455 55.8047C123.367 56.3302 123.367 57.1842 122.455 57.7097L87.0286 78.1741C86.5165 78.4332 85.9506 78.5682 85.3767 78.5682C84.8028 78.5682 84.2369 78.4332 83.7248 78.1741Z",
    fill: "#E8455C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M117.912 62.127L107.07 75.547L88.4795 86.2816V79.1213L117.912 62.127Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M116.367 82.7012L107.07 95.2248L88.4795 105.959V98.803L116.367 82.7012Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M116.367 102.377L107.07 114.901L88.4795 125.635V118.475L116.367 102.377Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_980_37294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.1358,
    height: 97.6733,
    fill: "white",
    transform: "translate(60.0068 42.1191)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.d665d749412a55bc775c1fc7a8b9848a.svg";
export { ForwardRef as ReactComponent };